import { AfterViewInit, Component} from '@angular/core';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';

@Component({
  selector: 'app-footer',
  imports: [FormsModule,ReactiveFormsModule],
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.css'
})
export class FooterComponent implements AfterViewInit{

  email = new FormControl('');

  ngAfterViewInit(): void {
    this.loadIubendaScript();
  }

  private loadIubendaScript(): void {
    const script = document.createElement('script');
    script.src = 'https://cdn.iubenda.com/iubenda.js';
    script.type = 'text/javascript';
    script.async = true;
    document.head.appendChild(script);
  }

  subscribe(){
  }
}
